<template>
  <div
    v-if="$root.isAdmin"
    class="admin-dashboard"
  >
    <h2>Admin Dashboard</h2>

    <div v-if="total === 0">
      Guess there isn't anything to do right now
    </div>
    <div
      v-else
      class="row responsive"
    >
      <div class="column">
        <h3>Reported Posts</h3>
        <div v-if="posts.length > 0">
          <reported-item
            v-for="post in posts"
            :key="post.id"
            :reported="post"
          />
        </div>
        <div v-else>
          There are no reported posts at this time
        </div>
      </div>
      <div class="column">
        <h3>Reported Comments</h3>

        <div v-if="comments.length > 0">
          <reported-item
            v-for="comment in comments"
            :key="comment.id"
            :reported="comment"
            type="comment"
          />
        </div>
        <div v-else>
          There are no reported comments at this time
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <h2>Not Found</h2>
    <router-link to="/">
      Go back to home page
    </router-link>
  </div>
</template>

<script>
import ReportedItem from '@/components/admin/ReportedItem.vue';

export default {
  name: 'AdminDashboard',
  components: {
    ReportedItem,
  },
  data() {
    return {
      posts: [],
      comments: [],
    };
  },
  computed: {
    total() {
      return this.posts.length + this.comments.length;
    },
  },
  async mounted() {
    await this.fetchReported();
  },
  methods: {
    async fetchReported() {
      if (this.$root.isAdmin) {
        const response = await this.api({
          url: 'users/reported/',
        });
        this.posts = response.body.posts;
        this.comments = response.body.comments;
      }
    },
  },
};
</script>

<style scoped>
  .admin-dashboard .column {
    flex: 1 1 50%;
  }
</style>
